import { apiV2 } from "../v2";
import { adminPopularRequest, adminPopularResponse } from "./dashboard.dto";

export const getAdminPopularApi = apiV2("GET", "/admin/dashboard/popular").withRequest(adminPopularRequest).withResponse(adminPopularResponse);
